// extracted by mini-css-extract-plugin
module.exports = {"imageSlider":"HomeBanner_imageSlider__2wCmH","HomeBanner":"HomeBanner_HomeBanner__2g_iL"};